import React from 'react'
import { MessageCircle } from 'lucide-react'
import { WHATSAPP_CONFIG } from '../constants'

const WhatsAppButton: React.FC = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_CONFIG.phoneNumber}?text=${encodeURIComponent(
    WHATSAPP_CONFIG.message
  )}`

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="shadow-luxury hover:shadow-luxury-hover animate-bounce-subtle fixed bottom-6 right-6 z-50 rounded-full bg-[#25D366] p-4 text-white transition-all duration-300 hover:scale-110 hover:bg-[#128C7E] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#25D366] focus-visible:ring-offset-2"
      aria-label={WHATSAPP_CONFIG.label}
      title={WHATSAPP_CONFIG.label}
    >
      <MessageCircle className="h-7 w-7" aria-hidden={true} />
    </a>
  )
}

export default WhatsAppButton
